import { render, staticRenderFns } from "./RSentimentBarChart.vue?vue&type=template&id=c77f9f54&"
import script from "./RSentimentBarChart.vue?vue&type=script&lang=js&"
export * from "./RSentimentBarChart.vue?vue&type=script&lang=js&"
import style0 from "./RSentimentBarChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
